import axios from '@/axios'

export default {
  getAll(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/spectators/event/${ id }`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  export(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/spectators/export/${ id }`)
        .then(() => {
          window.location = '/api/admin/download-export/spectators-' + id
          resolve()
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  }
}
